import { Navigate, Route, Routes } from 'react-router-dom';

import { Users } from './Users';
import { User } from './User';
import { SearchResults } from './SearchResults';
import { UsersVaults } from './UsersVaults';
import { VaultTransferSettings } from './VaultTransferSettings';
import { VaultDetails } from './VaultDetails';

export const UsersRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<Users />} />
      <Route path="vaults" element={<UsersVaults />} />
      <Route path="vaults/:id" element={<VaultDetails />} />
      <Route path="vault-transfer-settings" element={<VaultTransferSettings />} />
      <Route path="search-results" element={<SearchResults />} />
      <Route path=":id" element={<User />} />
      <Route path="*" element={<Navigate to="." />} />
    </Routes>
  );
};
